import { render } from "./Funfacts.vue?vue&type=template&id=008f7fdc&scoped=true"
import script from "./Funfacts.vue?vue&type=script&lang=js"
export * from "./Funfacts.vue?vue&type=script&lang=js"

import "./Funfacts.vue?vue&type=style&index=0&id=008f7fdc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008f7fdc"]])

export default __exports__